import {
    ALL_BUSES_LOADED,
    ADD_BUS_SUCCESS,
    UPDATE_BUS_SUCCESS,
    UPDATE_BUS_FAIL,
    REQUEST_DATA,
    UPDATE_INFANT_COUNT, UPDATE_CHILD_COUNT, UPDATE_ADULT_COUNT,
    UPDATE_REQUEST_DATA,
    ALL_CITIES
} from '../actions/types'
import moment from "moment";

const initialState = {

    token: typeof window !== "undefined" ? sessionStorage.getItem('token') : false,
    isAuthenticated: null,
    busesLoading: true,
    busLoading: true,
    buses: null,
    allCities: [],
    bus: null,
    requesInfo: {
        from: "",
        to: "",
        departureDate: moment().format("DD MMM YY"),
        returnDate: moment().format("DD MMM YY"),
        totalPassenger: '',
        tripType: "One Way",
        infantCount: 0,
        childCount: 0,
        adultCount: 1,
        modifyTrip: false
    }
}

export default function (state = initialState, action) {

    const { type, payload } = action

    switch (type) {
        // case LOGIN_SUCCESS:
        case ADD_BUS_SUCCESS:
            // sessionStorage.setItem('token', payload.token)
            return {
                ...state,
                ...payload,
                isAuthenticated: true,
                busLoading: false,
            }
        case UPDATE_BUS_SUCCESS:
            // sessionStorage.setItem('token', payload.token)
            return {
                ...state,
                ...payload,
                isAuthenticated: true,
                busLoading: false,
            }
        // case LOGIN_FAIL:
        // case AUTH_ERROR:
        case UPDATE_BUS_FAIL:
            // case LOGOUT:
            // localStorage.removeItem('token')
            return {
                ...state,
                token: null,
                isAuthenticated: false,
                busLoading: false
            }

        case ALL_BUSES_LOADED:
            return {
                ...state,
                isAuthenticated: true,
                loading: false,
                buses: payload
            }
        case ALL_CITIES:
            return {
                ...state,
                allCities: payload
            }
        case REQUEST_DATA:
            return {
                ...state,
                // isAuthenticated: true,
                // loading: false,
                requesInfo: payload
            }
        case UPDATE_REQUEST_DATA:
            return {
                ...state,
                // isAuthenticated: true,
                // loading: false,
                requesInfo: {
                    ...state.requesInfo,
                    from: payload.from,
                    to: payload.to,
                    departureDate: payload.departureDate,
                    returnDate: payload.returnDate,
                    totalPassenger: payload.totalPassenger,
                    tripType: payload.tripType,
                    infantCount: payload.infantCount,
                    childCount: payload.childCount,
                    adultCount: payload.adultCount,
                    modifyTrip: payload.hasOwnProperty('modifyTrip') ? payload.modifyTrip : false,
                }
            }
        case "UPDATE_TRIP_TYPE":
            return {
                ...state,
                requesInfo: {
                    ...state.requesInfo,
                    tripType: payload
                }
            };
        case "UPDATE_DEPARTURE_DATE":
            return {
                ...state,
                requesInfo: {
                    ...state.requesInfo,
                    departureDate: payload
                }
            };
        case "UPDATE_DATES":
            return {
                ...state,
                requesInfo: {
                    ...state.requesInfo,
                    departureDate: payload.departureDate,
                    returnDate: payload.returnDate
                }
            };
        case UPDATE_INFANT_COUNT:
            return {
                ...state,
                requesInfo: {
                    ...state.requesInfo,
                    infantCount: payload,
                    totalPassenger: action.payload + state.requesInfo.childCount + state.requesInfo.adultCount
                },
            };
        case UPDATE_CHILD_COUNT:
            return {
                ...state,
                requesInfo: {
                    ...state.requesInfo,
                    childCount: payload,
                    totalPassenger: state.requesInfo.infantCount + action.payload + state.requesInfo.adultCount
                },
            };
        case UPDATE_ADULT_COUNT:
            return {
                ...state,
                requesInfo: {
                    ...state.requesInfo,
                    adultCount: payload,
                    totalPassenger: state.requesInfo.infantCount + action.payload + state.requesInfo.childCount
                },
            };
        default:
            return state
    }
}